export default function appearance() {
    const toggle = document.querySelector('.lds-appearance');
    if (!toggle || !window.ldsAppearance) return;
    const sync = () => {
        const dark = document.documentElement.dataset.appearance === 'dark';
        const label = `Switch to ${dark ? 'light' : 'dark'} mode`;
        toggle.setAttribute('aria-label', label);
        toggle.title = label;
        toggle.querySelector('.lds-appearance-mobile-label').textContent = label;
    };
    toggle.addEventListener('click', () => {
        window.ldsAppearance.set(document.documentElement.dataset.appearance === 'dark' ? 'light' : 'dark');
    });
    document.addEventListener('lds:appearance', sync);
    sync();
}
